module.exports = __webpack_public_path__ + "media/1x1/sr-be27d1ae.svg";